import { createSelector } from '@reduxjs/toolkit';
import { RootInitialState } from 'core/common/store/rootReducer';
import { isActiveSubscription, isChatSubscription } from '../../entities';

export const getHasUserSubscription = (state: RootInitialState) => {
  return state.userSubscriptions.hasSubscription;
};

export const getUserSubscriptions = (state: RootInitialState) => {
  return state.userSubscriptions.subscriptions;
};

export const getIsActiveSubscription = createSelector(getUserSubscriptions, (subscriptions) => {
  const activeSubscriptions = subscriptions.filter(
    (item) => !isChatSubscription(item) && isActiveSubscription(item),
  );
  return !!activeSubscriptions.length;
});
